import { DeletedMaturityScheduleResponse } from '../../model/DeletedMaturitySchedule.model';
import axiosInstance from '../../utils/axiosInstance';

// Interface cho ApiResponse
interface ApiResponse<T> {
  success: boolean;
  message: string;
  data: T;
}

class DeletedMaturityScheduleService {
  private baseURL = '/maturity-schedule/deleted';

  // Lấy tất cả kỳ đáo hạn đã bị xóa
  async getAllDeletedMaturitySchedules(): Promise<
    DeletedMaturityScheduleResponse[]
  > {
    try {
      const response = await axiosInstance.get<
        ApiResponse<DeletedMaturityScheduleResponse[]>
      >(this.baseURL);
      return response.data?.data || [];
    } catch (error: any) {
      console.error('Error fetching deleted maturity schedules:', error);

      // Handle 404 or no data scenarios
      if (
        error.response?.status === 404 ||
        error.response?.data?.message?.includes('not found')
      ) {
        return [];
      }

      throw error;
    }
  }

  // Lấy kỳ đáo hạn đã bị xóa theo tháng và năm
  async getDeletedMaturitySchedulesByMonth(
    month: number,
    year: number
  ): Promise<DeletedMaturityScheduleResponse[]> {
    try {
      const response = await axiosInstance.get<
        ApiResponse<DeletedMaturityScheduleResponse[]>
      >(`${this.baseURL}/by-month`, {
        params: { month, year },
      });
      return response.data?.data || [];
    } catch (error: any) {
      console.error(
        'Error fetching deleted maturity schedules by month:',
        error
      );

      // Handle 404 or no data scenarios
      if (
        error.response?.status === 404 ||
        error.response?.data?.message?.includes('not found')
      ) {
        return [];
      }

      throw error;
    }
  }

  // Lấy kỳ đáo hạn đã bị xóa theo năm và thẻ
  async getDeletedMaturitySchedulesByYearAndCard(
    year: number,
    cardId: number
  ): Promise<DeletedMaturityScheduleResponse[]> {
    try {
      const response = await axiosInstance.get<
        ApiResponse<DeletedMaturityScheduleResponse[]>
      >(`${this.baseURL}/by-year-and-card`, {
        params: { year, cardId },
      });
      return response.data?.data || [];
    } catch (error: any) {
      console.error(
        'Error fetching deleted maturity schedules by year and card:',
        error
      );

      // Handle 404 or no data scenarios
      if (
        error.response?.status === 404 ||
        error.response?.data?.message?.includes('not found')
      ) {
        return [];
      }

      throw error;
    }
  }

  // Lấy kỳ đáo hạn đã bị xóa theo tháng, năm và thẻ
  async getDeletedMaturitySchedulesByMonthAndCard(
    month: number,
    year: number,
    cardId: number
  ): Promise<DeletedMaturityScheduleResponse[]> {
    try {
      const response = await axiosInstance.get<
        ApiResponse<DeletedMaturityScheduleResponse[]>
      >(`${this.baseURL}/by-month-and-card`, {
        params: { month, year, cardId },
      });
      return response.data?.data || [];
    } catch (error: any) {
      console.error(
        'Error fetching deleted maturity schedules by month and card:',
        error
      );

      // Handle 404 or no data scenarios
      if (
        error.response?.status === 404 ||
        error.response?.data?.message?.includes('not found')
      ) {
        return [];
      }

      throw error;
    }
  }
}

export default new DeletedMaturityScheduleService();
